var HotSpotManager = {
	spots:[],
	renderables: [],
	playerWidth:0,
	playerHeight:0,
	lastMore:null,
	visiblility:false,
	helpers:[],
	currentTransition:undefined,
	closest: null,
	keyListender: null,
	lastVisited: null,
	cursor3D: {},

	add: function(spot) {
		this.spots.push(spot);
	},

	addRenderable: function(r) {
		this.renderables.push(r);
		return r;
	},

	removeRenderable: function(item) {
		for(var r in this.renderables) {
			if (this.renderables[r] == item) {
				this.renderables[r].destroy();
				this.renderables.splice(r, 1);
				return;
			}
		}
	},

	setTransition: function(t) {
		HotSpotManager.currentTransition = t;
	},

	keyup: function(evt) {
		if (evt.key == "Enter" && HotSpotManager.closest.visible) {
			HotSpotManager.closest.proceed();
			evt.preventDefault();
			evt.stopPropagation();
			return false;
		}
	},

	clearRenderables: function() {
		for(var r in this.renderables) {
			this.renderables[r].destroy();
		}

		this.renderables = [];
	},

	setupLoader: function() {
		HotSpotManager.loader = $("<div class='game-loader'><div class='progress game-loader-bar'></div><div class='game-loader-indicator'></div><div class='game-loader-text'>Ładowanie gry ...</div></div>");
		HotSpotManager.showLoaded = true;
		$("#overlay").append(HotSpotManager.loader);
	},

	cycleProgress: function() {
		var total = 0;
		var loaded = 0;

		for(var r in HotSpotManager.renderables) {
			total += 2;
			if (HotSpotManager.renderables[r].holder.loaded) loaded += HotSpotManager.renderables[r].holder.loaded;
		}

		if (loaded < total) {
			HotSpotManager.showLoaded = true;
			HotSpotManager.loader.css("opacity", 1);
			var pr = Math.round((loaded / total) * 100);
			HotSpotManager.loader.find(".progress").css("width", pr + "%");
			HotSpotManager.loader.show();
			var l = Math.round((loaded / total) * 280);

			HotSpotManager.loader.find(".game-loader-indicator").css("left", l + "px");
			HotSpotManager.loader.find(".game-loader-indicator").css("opacity", (100 - pr) + "%");
		} else {
			var pr = Math.round((loaded / total) * 100);
			HotSpotManager.loader.find(".progress").css("width", pr + "%");
			var l = Math.round((loaded / total) * 280);

			HotSpotManager.loader.find(".game-loader-indicator").css("left", l + "px");
			HotSpotManager.loader.find(".game-loader-indicator").css("opacity", (100 - pr) + "%");

			if (HotSpotManager.showLoaded) {
				HotSpotManager.showLoaded = false;

				setTimeout(function() {
					HotSpotManager.loader.css("opacity", 0);
					setTimeout(function() {
						HotSpotManager.loader.hide();
					}, 1500);
				}, 300);
			}
		}
		//console.log(loaded + " / " + total);
	},

	addRenderableAsync: function(rra, type, no) {
		rra.settings.coords.x = parseFloat(rra.settings.coords.x);
		rra.settings.coords.y = parseFloat(rra.settings.coords.y);
		rra.settings.coords.z = parseFloat(rra.settings.coords.z);

		rra.settings.sphere.x = parseFloat(rra.settings.sphere.x);
		rra.settings.sphere.y = parseFloat(rra.settings.sphere.y);
		rra.settings.sphere.z = parseFloat(rra.settings.sphere.z);

		var placement = {
			"out": rra.settings.coords,
			"in": rra.settings.sphere
		};

		var ro;
		switch(type) {
			case "collectible":
				if (QuestManager.findQuestById(rra.collection_id) != -1 || player.cms == "1") {
					if (!ItemState.canSpawn(rra)) return;
					ro = HotSpotManager.addRenderable(new SphereSpot(new Collectible3D(rra, no), placement, {"type": "collectible", "record": rra}));
				}
			break;
			default:
				ro = HotSpotManager.addRenderable(new SphereSpot(new PlaneSpot3D("collect-" + rra.id, "/storage/collectibles/" + rra.image), placement, {'type': 'collectible', 'record': rra}));
		}
		if (player.cms == 1) ro.edit();
		
	},

	addRenderables: function(renderables, type) {
		if (renderables == undefined || renderables.length == 0) return;

		if (this.ilv == undefined) {
			this.setupLoader();
			this.ilv = setInterval(HotSpotManager.cycleProgress, 20);
		}

		for(var r in renderables) {
			var rra = renderables[r];

			var self = {'rra': rra, 'type': type};
			
//			setTimeout(function() {
				HotSpotManager.addRenderableAsync(self.rra, self.type, r);
//			}.bind(self), r * 200);
			
			/*
			rra.settings.coords.x = parseFloat(rra.settings.coords.x);
			rra.settings.coords.y = parseFloat(rra.settings.coords.y);
			rra.settings.coords.z = parseFloat(rra.settings.coords.z);

			rra.settings.sphere.x = parseFloat(rra.settings.sphere.x);
			rra.settings.sphere.y = parseFloat(rra.settings.sphere.y);
			rra.settings.sphere.z = parseFloat(rra.settings.sphere.z);

			var placement = {
				"out": rra.settings.coords,
				"in": rra.settings.sphere
			};

			var ro;

			switch(type) {
				case 'collectible':
					if (QuestManager.findQuestById(rra.collection_id) != -1 || player.cms == '1') {
						if (!ItemState.canSpawn(rra)) continue;
						ro = HotSpotManager.addRenderable(new SphereSpot(new Collectible3D(rra), placement, {'type': 'collectible', 'record': rra}));
					}
				break;
				default:
					ro = HotSpotManager.addRenderable(new SphereSpot(new PlaneSpot3D("collect-" + rra.id, "/storage/collectibles/" + rra.image), placement, {'type': 'collectible', 'record': rra}));
			}

			if (player.cms == 1) ro.edit();
			*/
		}
	},

	addAll: function(data, north) {

		if (HotSpotManager.closest == null) {
			HotSpotManager.closest = new ClosestSpot();
			HotSpotManager.lastVisited = $("<div style='position:absolute; padding: 5px;background-color:#00af00;border-radius: 100%;z-index:1;line-height:10px;border:2px solid #ffffff;'><i class='fa fa-check' style='color:#ffffff;font-size:10px;'></i></div>");
			$("#hotspots").append(HotSpotManager.lastVisited);
		}

		if (HotSpotManager.keyListender == null) {
			HotSpotManager.keyListender = 1;
			AppEvent.on(player, "PLAYER.KEYUP", HotSpotManager.keyup);
		}

		for(var spi in data) {
//			this.spots.push(new panoramaHotSpot(data[spi], spi, north));
//			console.log(data[spi]);
			if (data[spi].nomouse != "true") {
				if (isNaN(data[spi].x) && isNaN(data[spi].y)) continue;
				
				var spot = new panoramaHotSpot(data[spi], spi, 0);
				if (!spot.looted()) this.spots.push(spot);
				else {
					spot.remove();
					spot.removeHelper();
					delete spot;
				}

			}
		}
		
		//Console.place("dbcam" ,500,90,"^");
		this.dcam = new css3DNode("#dbcam");

	},

	findById: function(id) {
		for(var s in this.spots) {
			console.log(id + " = " + this.spots[s].properties.ident);
			if (parseInt(this.spots[s].properties.ident) == id) return this.spots[s];
		}

		return null;
	},
	
	hideWindow: function(e) {		
		if (HotSpotManager.lastMore != null) this.spots[HotSpotManager.lastMore].noMore();
	},
	
	more: function(k) {
		if (HotSpotManager.lastMore != null) this.spots[HotSpotManager.lastMore].noMore();
		
		for(var spi in this.spots) {
			if (this.spots[spi].no == k) {
				this.spots[spi].more();
				HotSpotManager.lastMore = spi;
			}
		}			
	},
	
	process3D: function(xx, yy, zoom) {
		var view = new Matrix3D();
		var viewY = new Matrix3D();
		var proj = new Matrix3D();
		var result = new Matrix3D();
		var dir = new Vector3D(0,0,1);
		
		HotSpotManager.helperMatrix = new Matrix3D();

		if (!HotSpotManager.visiblility) return;

		this.helpers = [];

		this.dcam.resetTransform();
		this.dcam.rotateZ(xx);
		this.dcam.applyTransforms();
		
		HotSpotManager.xx = xx;
		HotSpotManager.yy = yy;

		HotSpotManager.playerWidth = $("#player").width();
		HotSpotManager.playerHeight = $("#player").height();
		
		//Console.place("scrw" ,10,10,$("#player").width());
		
		//view = view.rotateY(xx * Math.PI / 180);
		view = view.rotateX(-yy * Math.PI / 180);
		view = view.rotateY(xx * Math.PI / 180);

		// helper transformation
		viewY = viewY.rotateX(-yy * Math.PI / 180);
		viewY = viewY.rotateY(-90 * Math.PI / 180);

//		view = view.rotateY((360 - xx) * Math.PI / 180);
		
		//var distance = 600;  // 490 bazowe z wlasciwosci css -webkit-perspective
		//var distance = 490;  // 490 bazowe z wlasciwosci css -webkit-perspective
		var distance = player.currentView.renderer.getPerspective();
		var fov = 2 * (Math.atan((HotSpotManager.playerHeight * 0.5) / distance) * 180 / Math.PI);
		//document.title = fov;
		//console.log(HotSpotManager.playerWidth * 0.5 + " = " + fov);
//		proj.makeProjection(103, $("#player").width() / $("#player").height(), 10, 1650);
//		proj.makeProjection(60, 1 / ($("#player").width() / $("#player").height()), 10, 1650);
//		proj.makeProjection(fov, 1 / ($("#player").width() / $("#player").height()), 10, 1650);
		proj.makeProjection(fov, 1 / ($("#player").width() / $("#player").height()), 10, 1650);
		
//		proj.makeProjection(128, $("#player").height() / $("#player").width(), 10, 1550);
//		proj.makeProjection(128, $("#player").width() / $("#player").height(), 10, 1550);
		
		// for helper calculations only for y position
		
		result = result.transform(view);
		result = result.transpose();
		result = result.transform(proj);

		HotSpotManager.helperMatrix = HotSpotManager.helperMatrix.transform(viewY);
		HotSpotManager.helperMatrix = HotSpotManager.helperMatrix.transpose();
		HotSpotManager.helperMatrix = HotSpotManager.helperMatrix.transform(proj);

		dir.transformByMatrix(view);
//		dir.transformByMatrix(result);
		
		//Console.put("dot_rotationX",220,30,dir.dot(new Vector3D(0,0,1)));

		HotSpotManager.lastVisited.css("visibility", "hidden");

		HotSpotManager.closest.resetDistance();

		var sx = $("#player").width() * 0.5;
		var sy = $("#player").height() * 0.5;

		var found = null;

		for(var spi in this.spots) {
			var pt = this.spots[spi].process(result, dir);
			if (pt == undefined) continue;

			var dy = (pt.y - sy) * 0.5;
			var d = ((pt.x - sx) * (pt.x - sx)) + (dy * dy);

			if (d < HotSpotManager.closest.d && this.spots[spi].closestIndicator) {
				//console.log("closest: " + d);
				HotSpotManager.closest.setDistance(d);
				found = {"dist": d, "spi": spi, "pt": pt};
			}

		} // a^2 + b^2 = c^2  c = sqrt(a^2 + b^2)

		if (found != null) {
			HotSpotManager.closest.setCoords(found.pt);
			HotSpotManager.closest.setSpot(this.spots[found.spi]);
		}

		for(var spi in this.renderables) {
			var pt = this.renderables[spi].process(result, dir);
		}

		// brzydki hack ktory refreshuje ekran i nie pozostawia plywajacych goracych punktow
		$("#hotspots").hide().show(0);

    	var playernode = $("body");

        var raycaster = new THREE.Raycaster();
        var mouse = new THREE.Vector2();

       	mouse.x = ( player._mouseHoverX / playernode.width()) * 2 - 1;
       	mouse.y = ( player._mouseHoverY / playernode.height()) * -2 + 1;

        raycaster.setFromCamera( mouse, player.currentView.renderer.camera );
        raycaster.layers.set(sphereWebGLStatic.cycle);
        HotSpotManager.cursor3D.raycaster = raycaster;
        HotSpotManager.cursor3D.intersects = raycaster.intersectObject( player.currentView.renderer.preview, false);
	},

	removeSpot: function(spot) {
		var found = -1;		
		for(var spi in this.spots) {
			if (this.spots[spi] == spot) {
				found = spi;
				break;
			}
		}
		if (found > -1) {
			this.spots[found].removeHelper();
			this.spots[found].remove();
			this.spots.splice(found, 1);
		}
	},

	clear: function() {
		if (HotSpotManager.lastVisited != null) HotSpotManager.lastVisited.css("visibility", "hidden");

		for(var spi in this.spots) {
			this.spots[spi].removeHelper();
			this.spots[spi].remove();
		}
		
		HotSpotManager.lastMore = null;
		
		HotSpotManager.spots = [];
	},

	setVisibility: function(b) {
		HotSpotManager.visiblility = b;
		if (b) {
			$("#hotspots").show();
			for(var spi in this.spots) {
				this.spots[spi].fadeIn();
			}
			//$(".hotspot").show();
		} else { 
			if (HotSpotManager.lastVisited != null) HotSpotManager.lastVisited.css("visibility", "hidden");
			$("#hotspots").hide();
			//$(".hotspot").hide();
		}
	},

	arrangeHelpers: function(nh) {
		var top = 2000;
		var bottom = -2000;

		for(var n in this.helpers) {
			var ch = this.helpers[n];
			if (ch.d == nh.d) {
				if (ch.y < top) top = ch.y;
				if (ch.y > bottom) bottom = ch.y;
			}
		}

		var dist_t = Math.abs(top - nh.y);
		var dist_b = Math.abs(nh.y - bottom);

		if (dist_t < 40) nh.y = top - 50;
		else if (dist_b < 40)  nh.y = bottom + 50;

		this.helpers.push(nh);

		return nh.y;
	},

	setLastVisited: function(spot, x, y) {
		HotSpotManager.lastVisited.css("left", x + 15);
		HotSpotManager.lastVisited.css("top", y - 25);
		HotSpotManager.lastVisited.css("visibility", "visible");
	}
}